export default "__VITE_ASSET__6qh$uFmr__"